/**
 * Consulta de fundo é a que não pertence à tela de destino: montada pelo layout
 * (header, menu, contextos que envolvem o dashboard inteiro) ou repetida por
 * polling. A porta de transição do dashboard (`RouteTransitionGate`) não espera
 * por ela: se esperasse, toda página aparecia só depois do layout terminar de
 * buscar, e o polling de 60 s podia prender a troca de tela.
 *
 * O `meta` fica na `Query`, e não no observer: no react-query v4 ela guarda as
 * opções de quem a criou ou de quem disparou a última busca. Se a mesma chave
 * também for usada por uma tela, vale a marca de quem buscou por último.
 */
export const BACKGROUND_QUERY_META = { background: true };

export const isBackgroundQuery = (query) => Boolean(query?.meta?.background);
